// Tamil content — same shape as content-en.js. Package names stay in English (official names).
export default {
  nav: {
    links: ["முகப்பு", "வெப்சைட் டெமோக்கள்", "ஏன் வெப்சைட்?", "சேவைகள்", "விலை", "எப்படி செயல்படுகிறது", "எங்களைப் பற்றி", "தொடர்பு"],
    cta: "என் வெப்சைட்டைப் பெறுக",
    whatsapp: "WhatsApp Disign Digital",
  },
  hero: {
    eyebrow: "உள்ளூர் வணிகங்களுக்கான தொழில்முறை வெப்சைட்கள்",
    titleA: "உங்கள் வணிகம் ஆன்லைனில்",
    titleB: "இருக்க வேண்டும்.",
    sub: "உங்கள் வணிகத்திற்காக வடிவமைக்கப்பட்ட தொழில்முறை வெப்சைட் — வாடிக்கையாளர்கள் உங்களைக் கண்டறிந்து, நம்பி, தொடர்பு கொள்ள.",
    ctaDemos: "வெப்சைட் டெமோக்களைப் பாருங்கள்",
    ctaWhats: "WhatsApp செய்யுங்கள்",
    location: "தென் இந்தியா முழுவதும் உள்ளூர் வணிகங்களுக்காக உருவாக்கப்பட்டது.",
    talk: "Anjum Kauser உடன் பேசுங்கள் — Business Growth Expert",
    demoTag: "வெப்சைட் டெமோ",
    browserUrl: "yourbusiness.com",
    starting: "₹4,999 முதல் வெப்சைட்கள்",
    startingTag: "We build. You grow.",
  },
  showroom: {
    eyebrow: "வெப்சைட் டெமோ அரங்கம்",
    title: "உங்கள் வணிகம் ஆன்லைனில் எப்படி இருக்கும் என்று பாருங்கள்",
    sub: "உங்கள் துறையைத் தேர்ந்தெடுத்து, உங்கள் வணிக வகைக்காக வடிவமைக்கப்பட்ட வெப்சைட்டை ஆராயுங்கள்.",
    filters: ["அனைத்தும்", "சில்லறை", "உணவு & விருந்தோம்பல்", "சுகாதாரம்", "தொழில்முறை சேவைகள்", "ஆட்டோ & வீடு", "கல்வி", "அழகு & வாழ்க்கைமுறை"],
    live: "நேரடி டெமோ",
    onRequest: "கோரிக்கையில் டெமோ",
    explore: "டெமோ வெப்சைட்டைப் பாருங்கள்",
    request: "இந்த டெமோவைக் கேளுங்கள்",
    otherPre: "உங்கள் துறை காணவில்லையா?",
    otherLink: "WhatsApp-ல் எங்களுக்குச் சொல்லுங்கள்",
    otherPost: "— எல்லா உள்ளூர் வணிகங்களுக்கும் நாங்கள் வெப்சைட் உருவாக்குகிறோம்.",
  },
  industries: [
    { name: "டயர் & ஆட்டோ கேர்", blurb: "டயர்கள், அலைன்மென்ட், பேலன்சிங் & ஆட்டோ கேர்" },
    { name: "கார் டீலர்", blurb: "புதிய & பழைய கார்கள், எளிய விசாரணைகளுடன்" },
    { name: "ரெஸ்டாரண்ட் & கஃபே", blurb: "மெனு, ஸ்பெஷல்கள் & WhatsApp ஆர்டர்கள்" },
    { name: "ஹோட்டல் & ரிசார்ட்", blurb: "அறைகள், வசதிகள் & முன்பதிவு விசாரணைகள்" },
    { name: "பல் கிளினிக்", blurb: "சிகிச்சைகள், மருத்துவர்கள் & அப்பாயிண்ட்மென்ட்கள்" },
    { name: "கிளினிக் & ஹெல்த்கேர்", blurb: "சேவைகள், நேரங்கள் & நோயாளர் விசாரணைகள்" },
    { name: "சலூன் & பியூட்டி", blurb: "சேவைகள், பேக்கேஜ்கள் & புக்கிங்கள்" },
    { name: "ஜிம் & ஃபிட்னஸ்", blurb: "மெம்பர்ஷிப்கள், ட்ரெய்னர்கள் & ஷெடியூல்கள்" },
    { name: "இன்டீரியர் டிசைனர்", blurb: "போர்ட்ஃபோலியோ, திட்டங்கள் & ஆலோசனைகள்" },
    { name: "பில்டர் & கான்டிராக்டர்", blurb: "திட்டங்கள், சொத்துக்கள் & விசாரணைகள்" },
    { name: "டியூஷன் & கோச்சிங்", blurb: "கோர்ஸ்கள், முடிவுகள் & சேர்க்கைகள்" },
    { name: "வழக்கறிஞர் & CA", blurb: "சேவைகள், அனுபவம் & ஆலோசனைகள்" },
    { name: "நகைக்கடை", blurb: "கலெக்ஷன்கள், பிரைடல் & விசாரணைகள்" },
    { name: "புட்டீக் & ஃபேஷன்", blurb: "கலெக்ஷன்கள், ஆஃபர்கள் & ஆர்டர்கள்" },
    { name: "போட்டோகிராஃபி", blurb: "போர்ட்ஃபோலியோ, பேக்கேஜ்கள் & புக்கிங்கள்" },
    { name: "திருமணம் & இவென்ட்ஸ்", blurb: "சேவைகள், கேலரி & விசாரணைகள்" },
    { name: "ஃபர்னிச்சர் ஸ்டோர்", blurb: "கேட்டலாக், ஆஃபர்கள் & விசாரணைகள்" },
    { name: "ஹோம் சர்வீசஸ்", blurb: "சேவைகள், பகுதிகள் & விரைவு புக்கிங்கள்" },
    { name: "பேக்கர்ஸ் & மூவர்ஸ்", blurb: "கோட்டுகள், சேவைகள் & தகவல்கள்" },
    { name: "பெட் கேர்", blurb: "குரூமிங், போர்டிங் & அப்பாயிண்ட்மென்ட்கள்" },
  ],
  why: {
    eyebrow: "ஏன் வெப்சைட்?",
    title: "உங்கள் வாடிக்கையாளர்கள் ஏற்கனவே தேடிக்கொண்டிருக்கிறார்கள்.",
    sub: "தினமும், உங்கள் அருகில் உள்ளவர்கள் நீங்கள் வழங்கும் சேவைகளையே தேடுகிறார்கள். வெப்சைட் அவர்கள் உங்களைக் கண்டறிந்து, நம்பி, தொடர்பு கொள்ள உதவுகிறது.",
    cards: [
      { title: "வருவதற்கு முன் தேடுகிறார்கள்", desc: "அழைப்பதற்கு அல்லது வருவதற்கு முன் வாடிக்கையாளர்கள் Google-ல் வணிகங்களைத் தேடுகிறார்கள். வெப்சைட் அவர்கள் உங்களைக் கண்டறிய உதவுகிறது." },
      { title: "முதல் அழைப்புக்கு முன் நம்பிக்கை", desc: "யாராவது பேசுவதற்கு முன்பே, தொழில்முறை வெப்சைட் நீங்கள் நம்பகமான, நிலையான வணிகம் என்பதைக் காட்டுகிறது." },
      { title: "எல்லாம் ஒரே இடத்தில்", desc: "உங்கள் சேவைகள், விலைகள், புகைப்படங்கள், நேரங்கள், இருப்பிடம் — அனைத்தும் உங்கள் கட்டுப்பாட்டில் ஒரே பக்கத்தில்." },
      { title: "எளிய விசாரணைகள்", desc: "ஒரே தட்டில் அழைப்பு அல்லது WhatsApp. தொடர்பு கொள்ள எளிதாக இருந்தால், அதிக விசாரணைகள் கிடைக்கும்." },
      { title: "உங்கள் வணிகம் 24/7 இயங்கும்", desc: "கடை மூடியிருந்தாலும், உங்கள் வெப்சைட் புதிய வாடிக்கையாளர்களிடம் உங்கள் வணிகத்தைக் காட்டிக்கொண்டே இருக்கும்." },
    ],
  },
  who: {
    eyebrow: "யாருக்கு வெப்சைட் தேவை?",
    title: "உங்கள் வணிகம் சொந்த வெப்சைட்டுக்குத் தயாரா?",
    sub: "வாடிக்கையாளர்கள் நீங்கள் செய்வதைத் தேடினால், தொழில்முறை வெப்சைட் அவர்கள் உங்களைத் தேர்வு செய்ய உதவுகிறது.",
    cards: [
      { name: "ரெஸ்டாரண்டுகள்", benefit: "மெனுவைக் காட்டி WhatsApp-ல் ஆர்டர்கள் பெறுங்கள்." },
      { name: "ஹோட்டல்கள்", benefit: "அறைகளைக் காட்டி நேரடி முன்பதிவு விசாரணைகள் பெறுங்கள்." },
      { name: "கிளினிக்குகள்", benefit: "சேவைகள், நேரங்கள், அப்பாயிண்ட்மென்ட் வசதியைப் பகிருங்கள்." },
      { name: "பல் மருத்துவர்கள்", benefit: "சிகிச்சைகளை விளக்கி நோயாளர்கள் முன்பதிவு செய்ய அனுமதியுங்கள்." },
      { name: "சலூன்கள்", benefit: "சேவைகள், விலைகளைப் பட்டியலிட்டு ஆன்லைன் புக்கிங் பெறுங்கள்." },
      { name: "ஜிம்கள்", benefit: "மெம்பர்ஷிப்கள், ட்ரெய்னர்கள், க்ளாஸ் ஷெடியூல்களைக் காட்டுங்கள்." },
      { name: "டயர் கடைகள்", benefit: "பிராண்டுகள், சேவைகளைக் காட்டி விசாரணைகள் பெறுங்கள்." },
      { name: "ஆட்டோ வொர்க்ஷாப்கள்", benefit: "சேவைகளைப் பட்டியலிட்டு புகைப்படங்களுடன் நம்பிக்கை உருவாக்குங்கள்." },
      { name: "கார் டீலர்கள்", benefit: "ஒவ்வொரு காரையும் புகைப்படம், விலையுடன் காட்டுங்கள்." },
      { name: "இன்டீரியர் டிசைனர்கள்", benefit: "உங்கள் போர்ட்ஃபோலியோவை புதிய திட்டங்களாக மாற்றுங்கள்." },
      { name: "பில்டர்கள்", benefit: "திட்டங்களை வாங்குபவர்களிடம் தொழில்முறையாக வழங்குங்கள்." },
      { name: "ரியல் எஸ்டேட்", benefit: "சொத்துக்களைக் காட்டி 24/7 விசாரணைகளைச் சேகரியுங்கள்." },
      { name: "வழக்கறிஞர்கள்", benefit: "உங்கள் சேவைத் துறைகளை விளக்கி நம்பகத்தன்மையை உருவாக்குங்கள்." },
      { name: "CA & ஆலோசகர்கள்", benefit: "சேவைகளைப் பட்டியலிட்டு வாடிக்கையாளர் நம்பிக்கையை முன்கூட்டியே பெறுங்கள்." },
      { name: "டியூஷன் மையங்கள்", benefit: "கோர்ஸ்கள், முடிவுகள், சேர்க்கை தகவல்களைக் காட்டுங்கள்." },
      { name: "போட்டோகிராஃபர்கள்", benefit: "உங்கள் போர்ட்ஃபோலியோ அதிக புக்கிங்களைப் பெறட்டும்." },
      { name: "திருமண வணிகங்கள்", benefit: "உங்கள் வேலையைக் காட்டி இவென்ட் விசாரணைகள் பெறுங்கள்." },
      { name: "நகைக்கடைகள்", benefit: "கலெக்ஷன்களைக் காட்டி WhatsApp விசாரணைகள் பெறுங்கள்." },
      { name: "புட்டீக்குகள்", benefit: "புதிய வரவுகளைக் காட்டி கஸ்டம் ஆர்டர்கள் பெறுங்கள்." },
      { name: "ஃபர்னிச்சர் கடைகள்", benefit: "உங்கள் கேட்டலாகை ஷோரூமுக்கு அப்பாலும் காட்டுங்கள்." },
      { name: "ஹோம் சர்வீசஸ்", benefit: "உள்ளூரில் கண்டறியப்பட்டு விரைவு புக்கிங்கள் பெறுங்கள்." },
    ],
  },
  services: {
    eyebrow: "சேவைகள்",
    title: "வெறும் வெப்சைட் மட்டும் அல்ல",
    sub: "வலுவான, தொழில்முறை டிஜிட்டல் முன்னிலையை உருவாக்க உங்கள் வணிகத்திற்குத் தேவையான அனைத்தும்.",
    items: [
      { title: "பிசினஸ் வெப்சைட்", desc: "உங்கள் வணிகத்தை அழகாக முன்வைக்கும் முழுமையான தொழில்முறை வெப்சைட்." },
      { title: "உள்ளூர் பிசினஸ் வெப்சைட்", desc: "உங்கள் பகுதியில் உங்கள் சேவைகளைத் தேடும் வாடிக்கையாளர்களுக்குக் கண்டறியப்பட." },
      { title: "கேட்டலாக் வெப்சைட்", desc: "உங்கள் முழு பொருட்கள் அல்லது சேவைகளைப் புகைப்படங்கள், விவரங்களுடன் காட்டுங்கள்." },
      { title: "லீட் ஜெனரேஷன் வெப்சைட்", desc: "பார்ம்கள், அழைப்புகள், WhatsApp மூலம் பார்வையாளர்களை விசாரணைகளாக மாற்ற." },
      { title: "அப்பாயிண்ட்மென்ட் / புக்கிங் வெப்சைட்", desc: "வாடிக்கையாளர்கள் நேரடியாக அப்பாயிண்ட்மென்ட் அல்லது ஸ்லாட் புக் செய்யட்டும்." },
      { title: "Google Business Profile ஆதரவு", desc: "உங்கள் Google Business Profile-ஐ அமைக்கவும் மேம்படுத்தவும் உதவி." },
      { title: "WhatsApp இன்டிக்ரேஷன்", desc: "ஒரே தட்டில் WhatsApp பட்டன்கள் — வாடிக்கையாளர்கள் உடனே மெசேஜ் செய்ய." },
      { title: "வெப்சைட் மெயின்டெனன்ஸ்", desc: "லான்ச்சுக்குப் பிறகு ஹோஸ்டிங், அப்டேட்டுகள், பேக்கப்புகள், தொழில்நுட்ப ஆதரவு." },
    ],
  },
  pricing: {
    eyebrow: "விலை",
    title: "உள்ளூர் வணிகங்களுக்கான தொழில்முறை வெப்சைட்கள்",
    sub: "வாடிக்கையாளர்கள் உங்கள் வணிகத்தைக் கண்டறிந்து, சேவைகளைப் பார்த்து, எளிதாகத் தொடர்பு கொள்ள உதவும் தொழில்முறை வெப்சைட்டுடன் உங்கள் வணிகத்தை ஆன்லைனில் கொண்டு வாருங்கள்.",
    oneTime: "ஒரு முறை கட்டணம்",
    recommended: "பரிந்துரை",
    plans: [
      {
        name: "Launch",
        positioning: "ஆன்லைனில் வாருங்கள்",
        note: "அடிப்படை தொழில்முறை ஆன்லைன் முன்னிலை தேவைப்படும் வணிகங்களுக்கு.",
        tag: "ஒரு முறை வெப்சைட் செட்டப்",
        cta: "தொடங்குங்கள்",
        features: [
          "தொழில்முறை பிசினஸ் வெப்சைட்", "மொபைல்-நட்பு வடிவமைப்பு", "5 பக்கங்கள் வரை",
          "வணிகத் தகவல் & சேவைகள்", "போட்டோ கேலரி", "WhatsApp பட்டன்",
          "Google Maps இன்டிக்ரேஷன்", "தொடர்பு/விசாரணை பார்ம்", "சோஷியல் மீடியா லிங்குகள்",
          "SSL பாதுகாப்பு", "வெப்சைட் செட்டப் & டெப்ளாய்மென்ட்", "1 வருட வெப்சைட் ஹோஸ்டிங்",
        ],
      },
      {
        name: "Business",
        positioning: "உங்கள் முன்னிலையை வளருங்கள்",
        note: "அடிப்படை ஆன்லைன் முன்னிலையை விட அதிகம் விரும்பும் வணிகங்களுக்கு சிறந்தது.",
        tag: "Launch-ல் உள்ள அனைத்தும் +",
        cta: "Business தேர்வு செய்க",
        features: [
          "8 பக்கங்கள் வரை", "பொருட்கள்/சேவைகள் கேட்டலாக்", "Google Reviews பகுதி",
          "விசாரணை/லீட் சேகரிப்பு", "அடிப்படை SEO செட்டப்", "Google Business Profile உதவி",
          "கூடுதல் கஸ்டமைசேஷன்", "2 முறை உள்ளடக்க/டிசைன் மாற்றங்கள்",
        ],
      },
      {
        name: "Business Pro",
        positioning: "விசாரணைகளை உருவாக்கி நிர்வகியுங்கள்",
        note: "வழக்கமான விசாரணைகள், புக்கிங்கள் அல்லது அப்பாயிண்ட்மென்ட்கள் பெறும் வணிகங்களுக்கு ஏற்றது.",
        tag: "Business-ல் உள்ள அனைத்தும் +",
        cta: "Pro-க்கு செல்லுங்கள்",
        features: [
          "ஆன்லைன் புக்கிங்/அப்பாயிண்ட்மென்ட் சிஸ்டம்", "மேம்பட்ட விசாரணை நிர்வாகம்", "கஸ்டமர் லீட் டாஷ்போர்டு",
          "பேமென்ட் இன்டிக்ரேஷன்", "தானியங்கு விசாரணை அறிவிப்புகள்", "மேம்பட்ட கஸ்டமைசேஷன்", "முன்னுரிமை ஆதரவு",
        ],
      },
    ],
    domainNote: "டொமைன் பதிவு உண்மையான கட்டணத்தில் தனியாக வசூலிக்கப்படும். டொமைன் உங்கள் வணிகப் பெயரில் பதிவு செய்யப்பட்டு உங்களுக்கே சொந்தம்.",
    compareTitle: "பேக்கேஜ்களை ஒப்பிடுங்கள்",
    featureCol: "அம்சம்",
    comparison: [
      ["தொழில்முறை வெப்சைட்", true, true, true],
      ["மொபைல் நட்பு", true, true, true],
      ["பக்கங்களின் எண்ணிக்கை", "5 வரை", "8 வரை", "8+"],
      ["போட்டோ கேலரி", true, true, true],
      ["WhatsApp", true, true, true],
      ["Google Maps", true, true, true],
      ["தொடர்பு பார்ம்", true, true, true],
      ["சோஷியல் லிங்குகள்", true, true, true],
      ["SSL", true, true, true],
      ["1 வருட ஹோஸ்டிங்", true, true, true],
      ["பொருட்கள்/சேவைகள் கேட்டலாக்", false, true, true],
      ["Google Reviews", false, true, true],
      ["லீட் சேகரிப்பு", false, true, true],
      ["அடிப்படை SEO", false, true, true],
      ["Google Business Profile உதவி", false, true, true],
      ["புக்கிங் சிஸ்டம்", false, false, true],
      ["லீட் டாஷ்போர்டு", false, false, true],
      ["பேமென்ட் இன்டிக்ரேஷன்", false, false, true],
      ["தானியங்கு அறிவிப்புகள்", false, false, true],
      ["முன்னுரிமை ஆதரவு", false, false, true],
    ],
    maintenance: {
      eyebrow: "இரண்டாம் வருடம் முதல்",
      title: "உங்கள் வெப்சைட்டை சீராக இயக்குங்கள்",
      perYear: "/ வருடம்",
      features: ["வெப்சைட் ஹோஸ்டிங்", "SSL", "தொழில்நுட்ப பராமரிப்பு", "வெப்சைட் பேக்கப்புகள்", "சிறிய உள்ளடக்க அப்டேட்டுகள்", "வெப்சைட் மானிட்டரிங்", "தொழில்நுட்ப ஆதரவு"],
      note: "டொமைன் ரெனியூவல் சேர்க்கப்படவில்லை. ரெஜிஸ்ட்ராரின் உண்மையான ரெனியூவல் விலையில் தனியாக வசூலிக்கப்படும். கட்டாய மாதாந்திர வெப்சைட் சப்ஸ்கிரிப்ஷன் இல்லை.",
    },
    optional: {
      eyebrow: "கூடுதல் சேவைகள்",
      title: "இன்னும் ஏதாவது வேண்டுமா?",
      items: [
        { name: "பிசினஸ் ஈமெயில்", price: "₹999/வருடம் முதல்", note: "+ ஈமெயில் வழங்குநர் கட்டணம்" },
        { name: "கூடுதல் வெப்சைட் பக்கங்கள்", price: "₹499/பக்கம்", note: "" },
        { name: "கூடுதல் டிசைன் / கஸ்டமைசேஷன்", price: "தேவைக்கேற்ப மதிப்பீடு", note: "" },
        { name: "வெப்சைட் கண்டென்ட் ரைட்டிங்", price: "₹999 முதல்", note: "" },
        { name: "லோகோ டிசைன்", price: "₹999 முதல்", note: "" },
      ],
      cta: "WhatsApp-ல் விசாரியுங்கள்",
    },
    trust: {
      title: "எளிய விலை. நீண்டகால கடமை இல்லை.",
      big: "ஒரு முறை செலுத்துங்கள். உங்கள் வெப்சைட்டை லைவ் ஆக்குங்கள்.",
      body: "கட்டாய மாதாந்திர வெப்சைட் சப்ஸ்கிரிப்ஷன் இல்லை. உங்கள் டொமைன் உங்கள் வணிகப் பெயரில் பதிவு செய்யப்பட்டு, உங்கள் ஆன்லைன் அடையாளத்தின் உரிமையும் கட்டுப்பாடும் உங்களிடமே இருக்கும்.",
      clarification: "டொமைன் பதிவு மற்றும் ரெனியூவல் தனிக் கட்டணங்கள்; ரெஜிஸ்ட்ராரின் உண்மையான விலையில் வசூலிக்கப்படும்.",
      cta: "WhatsApp-ல் விலை பற்றிப் பேசுங்கள்",
    },
  },
  steps: {
    eyebrow: "எப்படி செயல்படுகிறது",
    title: "முதல் உரையாடலில் இருந்து லைவ் வெப்சைட் வரை",
    sub: "எளிய, வழிகாட்டப்பட்ட செயல்முறை — உங்களிடம் தொழில்நுட்ப அறிவு தேவையில்லை.",
    stepLabel: "படி",
    items: [
      { title: "உங்கள் வணிகத்தைப் பற்றிச் சொல்லுங்கள்", desc: "நீங்கள் என்ன செய்கிறீர்கள், உங்கள் சேவைகள், வாடிக்கையாளர்களுக்குத் தேவையான தகவல்களைப் பகிருங்கள்." },
      { title: "உங்கள் வெப்சைட் ஸ்டைலைத் தேர்வு செய்யுங்கள்", desc: "எங்கள் இண்டஸ்ட்ரி டெமோக்களில் இருந்து ஒரு லுக் தேர்வு செய்யுங்கள் அல்லது உங்களுக்குப் பிடித்த ஸ்டைலைச் சொல்லுங்கள்." },
      { title: "நாங்கள் உங்கள் வெப்சைட்டை உருவாக்குகிறோம்", desc: "உங்கள் முழுமையான தொழில்முறை வெப்சைட்டை வடிவமைத்து, எழுதி, அமைக்கிறோம்." },
      { title: "லைவ் ஆகி ஷேர் செய்யத் தொடங்குங்கள்", desc: "உங்கள் வெப்சைட் லைவ் ஆகிறது. WhatsApp, Google, சோஷியல் மீடியாவில் ஷேர் செய்யுங்கள்." },
    ],
    growPre: "பிறகு —",
    growBold: "எங்களுடன் வளருங்கள்",
    growPost: ". உங்கள் வணிகத்திற்குத் தேவைப்படும்போதெல்லாம் தொடர்ந்த டிஜிட்டல் ஆதரவு.",
  },
  beforeAfter: {
    eyebrow: "முன் vs பின்",
    title: "கண்டறியப்படுவதில் இருந்து நம்பப்படுவது வரை",
    without: "வெப்சைட் இல்லாமல்",
    with: "தொழில்முறை வெப்சைட்டுடன்",
    withoutItems: [
      "குறைந்த தகவல்",
      "சேவைகளைக் காட்டுவது கடினம்",
      "சோஷியல் மீடியாவை அதிகம் சார்ந்திருத்தல்",
      "ஆன்லைன் முன்னிலையில் குறைந்த கட்டுப்பாடு",
      "போட்டியாளர்கள் அதிக தொழில்முறையாகத் தெரியலாம்",
    ],
    withItems: [
      "தெளிவான வணிகத் தகவல்",
      "சேவைகள்/பொருட்கள் தொழில்முறையாக வழங்கப்படுகின்றன",
      "எளிய WhatsApp & அழைப்பு விசாரணைகள்",
      "வலுவான டிஜிட்டல் முன்னிலை",
      "ஷேர் செய்ய எளிது",
      "24/7 கிடைக்கும்",
    ],
  },
  journey: {
    eyebrow: "வாடிக்கையாளர் பயணம்",
    title: "ஆன்லைன் கண்டுபிடிப்பை உண்மையான உரையாடலாக மாற்றுங்கள்.",
    sub: "Google-ல் தேடும் அந்நியரை உங்கள் அடுத்த வாடிக்கையாளராக தொழில்முறை வெப்சைட் எப்படி மாற்றுகிறது என்பது இதுதான்.",
    steps: ["Google தேடல்", "பிசினஸ் வெப்சைட்", "நம்பிக்கை", "WhatsApp / அழைப்பு", "விசாரணை", "வாடிக்கையாளர்"],
  },
  benefits: {
    eyebrow: "முக்கியமான முடிவுகள்",
    title: "உங்கள் வெப்சைட் உங்கள் வணிகத்திற்கு என்ன செய்ய முடியும்",
    sub: "வாடிக்கையாளர் கருத்துகள் விரைவில் — தொழில்முறை வெப்சைட் உங்களுக்காக என்ன செய்ய வடிவமைக்கப்பட்டுள்ளது என்பது இங்கே.",
    cards: [
      { title: "கண்டறியப்படுங்கள்", desc: "மக்கள் உங்கள் சேவைகளைத் தேடும்போது, உங்கள் வெப்சைட் அவர்களுக்குத் தொழில்முறையான இடத்தைத் தருகிறது." },
      { title: "நம்பிக்கையை உருவாக்குங்கள்", desc: "முதல் உரையாடலுக்கு முன்பே — உங்கள் சேவைகள், புகைப்படங்கள், வணிக விவரங்கள் தொழில்முறையாக வழங்கப்படுகின்றன." },
      { title: "விசாரணைகளைப் பெறுங்கள்", desc: "ஒரே தட்டில் அழைப்பு & WhatsApp பட்டன்கள் வாடிக்கையாளர்கள் உங்களை அடைவதை எளிதாக்குகிறது." },
    ],
  },
  faq: {
    eyebrow: "கேள்விகள்",
    title: "வணிக உரிமையாளர்கள் எங்களிடம் கேட்கும் கேள்விகள்",
    sub: "சுருக்கமான, நேர்மையான பதில்கள். இன்னும் சந்தேகமா? எப்போது வேண்டுமானாலும் WhatsApp செய்யுங்கள்.",
    items: [
      { q: "Instagram இருந்தாலும் என் வணிகத்திற்கு ஏன் வெப்சைட் தேவை?", a: "Instagram ஃபாலோயர்களுக்கு நல்லது, ஆனால் வாடிக்கையாளர்கள் வாங்குவதற்கு முன் Google-ல் தேடுகிறார்கள். வெப்சைட் உங்கள் சொந்த இடம் — உங்கள் சேவைகள், புகைப்படங்கள், விலைகள், தொடர்பு பட்டன்களுடன் — முழுக் கட்டுப்பாடு உங்களிடம்." },
      { q: "ஏற்கனவே Google Business Profile உள்ளது. பிறகு ஏன் வெப்சைட்?", a: "Google Business Profile மக்கள் உங்களைக் கண்டறிய உதவுகிறது. வெப்சைட் அவர்கள் உங்களைத் தேர்வு செய்யச் சம்மதிக்க வைக்கிறது — முழு விவரங்கள், புகைப்படங்கள், சேவைகள், எளிய விசாரணை பட்டன்களுடன். இரண்டும் சேர்ந்தால் சிறந்தது." },
      { q: "தொழில்நுட்ப அறிவு தேவையா?", a: "ஒட்டுமொத்தமாகத் தேவையில்லை. டிசைன், செட்டப், ஹோஸ்டிங், அப்டேட்டுகள் — எல்லாவற்றையும் நாங்கள் கையாளுகிறோம். நீங்கள் உங்கள் வணிகத்தைப் பற்றிச் சொன்னால் போதும்." },
      { q: "வாடிக்கையாளர்கள் WhatsApp மூலம் தொடர்பு கொள்ள முடியுமா?", a: "ஆம். நாங்கள் உருவாக்கும் ஒவ்வொரு வெப்சைட்டிலும் ஒரே தட்டில் WhatsApp மற்றும் அழைப்பு பட்டன்கள் இருக்கும் — வாடிக்கையாளர்கள் உடனே உங்களை அடையலாம்." },
      { q: "என் துறைக்காக பிரத்யேகமாக வெப்சைட் உருவாக்க முடியுமா?", a: "ஆம். ரெஸ்டாரண்டுகள், கிளினிக்குகள், சலூன்கள், டயர் கடைகள், பில்டர்கள் உட்பட பல துறைகளுக்கு நாங்கள் வெப்சைட் வடிவமைக்கிறோம். உதாரணங்களைப் பார்க்க எங்கள் டெமோ அரங்கத்தை ஆராயுங்கள்." },
      { q: "முடிவு செய்வதற்கு முன் டெமோ பார்க்க முடியுமா?", a: "நிச்சயமாக. இந்தப் பக்கத்தில் உள்ள டெமோ வெப்சைட்களைப் பாருங்கள், அல்லது WhatsApp செய்யுங்கள் — உங்கள் வணிக வெப்சைட் எப்படி இருக்கும் என்று காட்டுகிறோம்." },
      { q: "பிறகு என் வெப்சைட்டை அப்டேட் செய்ய முடியுமா?", a: "ஆம். எப்போது வேண்டுமானாலும் அப்டேட் செய்யலாம் — புதிய புகைப்படங்கள், சேவைகள், விலைகள், பக்கங்கள். பேக்கேஜ்களில் மாற்ற வாய்ப்புகள் உள்ளன; வருடாந்திர பராமரிப்பு சிறிய அப்டேட்டுகளைக் கவரும்." },
      { q: "டொமைன் மற்றும் ஹோஸ்டிங்கில் உதவுவீர்களா?", a: "ஆம். எல்லாவற்றையும் நாங்கள் அமைக்கிறோம். உங்கள் டொமைன் உங்கள் வணிகப் பெயரில் பதிவாகி உங்களுக்கே சொந்தம். முதல் வருட ஹோஸ்டிங் எல்லா பேக்கேஜ்களிலும் சேர்க்கப்பட்டுள்ளது." },
      { q: "எவ்வளவு நேரம் ஆகும்?", a: "உங்கள் வணிக விவரங்கள் மற்றும் புகைப்படங்கள் கிடைத்ததும், பெரும்பாலான வெப்சைட்கள் சில வேலை நாட்களில் தயாராகிவிடும். தொடங்குவதற்கு முன் காலக்கெடுவை உறுதி செய்வோம்." },
      { q: "வெப்சைட் லான்ச் ஆன பிறகு என் ஆன்லைன் முன்னிலையை மேம்படுத்த உதவுவீர்களா?", a: "ஆம். Google Business Profile ஆதரவு முதல் உள்ளடக்க அப்டேட்டுகள், புதிய அம்சங்கள் வரை — லான்ச்சுக்குப் பிறகும் உங்கள் டிஜிட்டல் வளர்ச்சிக்கு நாங்கள் தொடர்ந்து ஆதரவு அளிக்கிறோம்." },
    ],
  },
  about: {
    eyebrow: "Disign Digital பற்றி",
    title: "உள்ளூர் வணிகங்களுக்கான டிஜிட்டல் வளர்ச்சி பார்ட்னர்",
    p1: "Disign Digital சிறிய மற்றும் நடுத்தர உள்ளூர் வணிகங்கள் தொழில்முறை டிஜிட்டல் முன்னிலையை உருவாக்க உதவுகிறது — வாடிக்கையாளர்கள் அவர்களை எளிதாகக் கண்டறிந்து, நம்பி, தொடர்பு கொள்ள.",
    p2: "மதுரையில் உள்ள டயர் கடை முதல் கொச்சியில் உள்ள புட்டீக் வரை — ஒவ்வொரு உள்ளூர் வணிகமும் பெரிய பிராண்டைப் போலவே தரமான ஆன்லைன் முன்னிலைக்குத் தகுதியானது என்று நாங்கள் நம்புகிறோம். தொழில்முறை வெப்சைட்கள், நேர்மையான விலை, லான்ச்சுக்குப் பிறகும் தொடரும் ஆதரவு.",
    signature: "Anjum Kauser — Business Growth Expert at Disign Digital",
    valuesTitle: "நாங்கள் நம்புவது",
    values: [
      { t: "நேர்மையான விலை", d: "வெப்சைட்டுக்கு ஒரு முறை செலுத்துங்கள். கட்டாய மாதாந்திர சப்ஸ்கிரிப்ஷன் இல்லை." },
      { t: "உங்கள் உரிமை", d: "உங்கள் டொமைன் உங்கள் வணிகப் பெயரில் பதிவாகிறது — அது உங்களுடையது." },
      { t: "உள்ளூர் வணிகத்திற்காக", d: "உண்மையான வாடிக்கையாளர்களுக்கான எளிய, நடைமுறை வெப்சைட்கள்." },
      { t: "லான்ச்சுக்குப் பிந்தைய ஆதரவு", d: "உங்கள் வெப்சைட் தொடர்ந்து இயங்க ஹோஸ்டிங், அப்டேட்டுகள், தொழில்நுட்ப உதவி." },
    ],
  },
  contact: {
    eyebrow: "தொடர்பு",
    title: "உங்கள் டிஜிட்டல் முன்னிலையை உருவாக்குவோம்",
    sub: "உங்கள் வணிகத்தைப் பற்றிச் சொல்லுங்கள். உங்கள் வெப்சைட் எப்படி இருக்கும் என்று காட்டுகிறோம்.",
    intro: "எங்களை அடைய எளிய வழி WhatsApp. உங்கள் வணிகப் பெயர் மற்றும் ஊரைப் பகிருங்கள் — மற்றதை நாங்கள் பார்த்துக்கொள்கிறோம்.",
    whatsappLabel: "WhatsApp:",
    chat: "WhatsApp-ல் பேசுங்கள்",
    requestDemo: "வெப்சைட் டெமோ கேளுங்கள்",
  },
  form: {
    name: "பெயர்", namePh: "உங்கள் பெயர்",
    business: "வணிகத்தின் பெயர்", businessPh: "உங்கள் வணிகத்தின் பெயர்",
    phone: "தொலைபேசி எண்", phonePh: "உங்கள் WhatsApp எண்",
    city: "ஊர்", cityPh: "உங்கள் ஊர்",
    category: "வணிக வகை", categoryPh: "உங்கள் வணிக வகையைத் தேர்வு செய்யுங்கள்",
    hasWebsite: "ஏற்கனவே வெப்சைட் உள்ளதா?", yes: "ஆம்", no: "இல்லை",
    need: "உங்களுக்கு என்ன தேவை?", needPh: "உங்கள் வணிகம் மற்றும் தேவையைச் சுருக்கமாகச் சொல்லுங்கள்",
    submit: "என் டெமோவைக் கேளுங்கள்", sending: "அனுப்புகிறது…",
    privacy: "உங்கள் தனியுரிமையை நாங்கள் மதிக்கிறோம். உங்கள் விவரங்கள் வெப்சைட் பற்றி உங்களைத் தொடர்பு கொள்ள மட்டுமே பயன்படும்.",
    success: "நன்றி! Disign Digital-லிருந்து Anjum விரைவில் உங்களைத் தொடர்பு கொள்வார்.",
    successSub: "விரைவான பதில் வேண்டுமா? இப்போதே மெசேஜ் செய்யுங்கள்.",
    successCta: "WhatsApp-ல் பேசுங்கள்",
    other: "மற்றவை",
  },
  finalCta: {
    title: "உங்கள் வணிகத்தை ஆன்லைனில் கொண்டு வரத் தயாரா?",
    sub: "நீங்கள் என்ன செய்கிறீர்கள் என்று சொல்லுங்கள். உங்கள் வணிக வெப்சைட் எப்படி இருக்கும் என்று காட்டுகிறோம்.",
    cta1: "என் வெப்சைட்டைப் பெறுக",
    cta2: "WhatsApp Anjum",
    small: "Anjum Kauser — Business Growth Expert at Disign Digital",
  },
  footer: {
    tagline: "Digital Presence. Real Business.",
    desc: "உள்ளூர் வணிகங்களுக்கான தொழில்முறை வெப்சைட்கள். வலுவான டிஜிட்டல் முன்னிலையுடன் உள்ளூர் வணிகங்கள் வளர உதவுகிறது.",
    explore: "ஆராயுங்கள்",
    contact: "தொடர்பு",
  },
  sticky: { whatsapp: "WhatsApp செய்யுங்கள்", getWebsite: "என் வெப்சைட்டைப் பெறுக" },
};
